import * as t from "react";
var a = globalThis?.document ? t.useLayoutEffect : () => {
};
export {
  a as u
};
